import { workCodeProxy } from './index';
// proxy/work/code/1.0/

/* [ 코드 ] */
// work코드
function getWorkCommonCode(params) {
  return workCodeProxy.get(`list`, { params });
}

export { getWorkCommonCode };
